import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const VIEW_SIZE_REQUEST = 'VIEW_SIZE_REQUEST';
export const VIEW_SIZE_SUCCESS = 'VIEW_SIZE_SUCCESS';
export const VIEW_SIZE_ERROR = 'VIEW_SIZE_ERROR';
export const RESET_VIEW_SIZE = 'RESET_VIEW_SIZE';


export const viewSize = (id) => {
    let headers = getHeaderWithToken();
    return dispatch => {
        return new Promise(function (resolve, reject) {

            dispatch({
                type: VIEW_SIZE_REQUEST
            })
            axios({
                method: 'GET',
                url: `${SERVER_URL}v1/patterns/size/${id}`,
                headers: headers,

            }).then(function (response) {
                dispatch({
                    type: VIEW_SIZE_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: VIEW_SIZE_ERROR,
                        payload: error
                    })
                    reject(error)
                })

        })

    }
}



export const resetViewSize = () => {
    return dispatch => {
        dispatch({
            type: RESET_VIEW_SIZE
        })
    }
}